export default "__VITE_ASSET__Bvm$wqvb__"